import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays a value with optional strikethrough of the previous value when changes are detected.
 * Supports both primitive values and React elements with custom equality checks.
 *
 * @param {object} props
 * @param {node} props.currentValue - The current value to display (can be string, number, or React element)
 * @param {node} props.previousValue - The previous value to show with strikethrough if changed
 * @param {bool} props.showOriginalValues - Flag to control whether to display previous values with strikethrough
 * @return {JSX.Element}
 */
const ValueWithStrikethroughChanges = ({ currentValue, previousValue, showOriginalValues }) => {
  const hasChanged = showOriginalValues && previousValue && (currentValue?.type?.equals ?
    !currentValue.type.equals(currentValue.props, previousValue.props) :
    currentValue !== previousValue);
  return (
    <>
      {currentValue}
      {hasChanged && (
        <>
          {' '}
          <span className="line-through ml-2">{previousValue}</span>
        </>
      )}
    </>
  );
};

ValueWithStrikethroughChanges.propTypes = {
  currentValue: PropTypes.node.isRequired,
  previousValue: PropTypes.node,
  showOriginalValues: PropTypes.bool.isRequired,
};

ValueWithStrikethroughChanges.defaultProps = {
  previousValue: null,
};

export default ValueWithStrikethroughChanges;
